import { AppSettings } from '../../../../appSettings';

/* Backend returns relative paths (/assets/…). Prefix with the API origin for
   display; leave absolute / blob / data URLs untouched. Stored value stays
   relative — matches the rest of the app. */
export const resolveMediaUrl = (src: string): string =>
  !src || /^(https?:|blob:|data:)/.test(src) ? src : AppSettings.api.url + src;
